;
define("header_menu_myaccount.tpl", function(){});

